import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { SmartButton } from '../common/SmartButton';

import * as contentUtils from '../../utils/contentUtils';
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';
import CustomIcon from '../common/CustomIcon';
import DesynchronizeDropdown from '../book/desynchronizeBook/DesynchronizeDropdown';
import * as bookActions from '../../actions/bookActions';
import * as drawerActions from '../../actions/drawerActions';
import GroupAssignedTile from '../common/GroupAssignedTile';

class BookButtonsContainer extends Component {
  renderReDownloadButton = () => {
    const { isAppOnline, handleReDownloadButton, contentBooks, book } = this.props;
    const isBookDownloaded = contentUtils.isStoreContentBookDownloaded(book, contentBooks);

    if (this.canDownload() && isBookDownloaded) {
      return (
        <SmartButton
          className={!book.description ? 'with-margin book-action-button' : 'book-action-button'}
          onClick={handleReDownloadButton}
          disabled={!isAppOnline}
          success
        >
          <CustomIcon name="download-tray" size={15} />
          <span>{I18n.t('common.option.reDownload')}</span>
        </SmartButton>
      );
    }
  };

  renderDownloadButton() {
    const { isAppOnline, handleDownloadButton, contentBooks, book } = this.props;
    const isBookDownloaded = contentUtils.isStoreContentBookDownloaded(book, contentBooks);

    if (this.canDownload() && !isBookDownloaded) {
      return (
        <SmartButton
          className={!book.description ? 'with-margin book-action-button' : 'book-action-button'}
          onClick={handleDownloadButton}
          disabled={!isAppOnline}
          success
        >
          <CustomIcon name="download-tray" size={15} />
          <span>{I18n.t('common.option.download')}</span>
        </SmartButton>
      );
    }
  }

  canDownload = () => {
    const { isPreview, contentBooks, book } = this.props;
    const isBookDownloading = contentUtils.isStoreContentBookSaving(book, contentBooks);
    const isSynchronizing = contentUtils.isStoreContentBookSynchronizing(book, contentBooks);

    return Object.keys(book).length !== 0 && !isPreview && isElectronApp() && !isBookDownloading && !isSynchronizing;
  };

  render() {
    const { isPreview, withMargin, role, groups, book } = this.props;

    return (
      <div className={'buttons-container ' + (withMargin ? 'with-margin' : '')}>
        {!isPreview && <DesynchronizeDropdown />}
        <GroupAssignedTile
          assignedGroup={book.configuration}
          groups={groups}
          ligthColor={true}
          role={role}
          withMargin={!book.description}
        />
        <div style={{ flex: '1' }} />
        {this.renderReDownloadButton()}
        {this.renderDownloadButton()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  role: state.classrooms.selectedClassroom.classroom.role,
  classroom: state.classrooms.selectedClassroom.classroom,
  isAppOnline: state.connection.status.online,
  contentBooks: state.content.contentBooks,
  groups: state.classrooms.selectedClassroom ? state.classrooms.selectedClassroom.groups : {}
});

const mapDispatchToProps = dispatch => ({
  bookActions: bindActionCreators(bookActions, dispatch),
  drawerActions: bindActionCreators(drawerActions, dispatch),
  dispatch
});

BookButtonsContainer.propTypes = {
  book: PropTypes.object,
  classroom: PropTypes.object,
  isComplete: PropTypes.bool,
  isPreview: PropTypes.bool,
  bookActions: PropTypes.any,
  unitId: PropTypes.any,
  isAppOnline: PropTypes.any,
  drawerActions: PropTypes.any,
  contentBooks: PropTypes.object,
  role: PropTypes.string,
  handleReDownloadButton: PropTypes.func,
  handleDownloadButton: PropTypes.func,
  withMargin: PropTypes.bool,
  groups: PropTypes.any
};

export default connect(mapStateToProps, mapDispatchToProps)(BookButtonsContainer);
